module.exports = __webpack_public_path__ + "img/img-left.4267ddf5.png";